import React, { useContext, useState, useEffect, useRef } from 'react';
import { dataSender, navigateV2 } from '../../../common/utils/router';
import { Portal } from '../../../hybrid/wrappers';
import SingleButton from '../../form/form-control-buttons/SingleButton/SingleButton';
import { declOfNum, API_SERVER_URL } from '../../../common/utils/utils';
import UserContext from '../../../common/utils/getContext';
import { useWindowDimensions, useWindowDimensionsHeight } from '../../../common/utils/windowDimensions';
import FormButtons from '../../form/form-control-buttons/FormButtons/FormButtons';
import { t } from '../../../common/components/T';
import { LangContext } from '../../../common/decorators/Language';
import DropdownElement from '../../../hybrid/library/DropdownElement';
import { getStylePropsFunc } from '../../../common/utils/styles';

const SelectElement = ({ compStyles, activeElem, setActiveElem, selectData, selectElementItemsArr, translation }) => {
    const getStyleProps = (...keys) => getStylePropsFunc(compStyles, ...keys);

    const { userToken, setAlertData, lang } = useContext(UserContext);
    const [elAgree, setElAgree] = useState(false);
    const [selectedElLengthItems, setSelectedElLengthItems] = useState(
        selectElementItemsArr ? selectElementItemsArr[0].title : ''
    );
    const allTranslation = useContext(LangContext) || {};
    const changeSelectElement = (e) => {
        setSelectedElLengthItems(e.value);
        setElAgree(true);
    };
    const changeFunc = async () => {
        const newItem = selectElementItemsArr.filter((el) => el.title === selectedElLengthItems);
        const getData = (url) =>
            new Promise((resolve) => {
                dataSender(
                    url,
                    'POST',
                    {
                        ids: activeElem,
                        status: newItem[0].id
                    },
                    (response) => {
                        setActiveElem([]);
                        resolve(response.data);
                    },
                    (data) => {
                        if (data.message) {
                            resolve({ globalErr: data.message });
                        } else {
                            resolve(false);
                        }
                    },
                    userToken,
                    lang
                );
            });
        const data = await getData(`${API_SERVER_URL}/api/v1/admin/shop/orders/batch-status-update`);
        const globalErr = data.globalErr || data.globalErr;
        if (globalErr) {
            setAlertData({ type: 'error', cont: globalErr });
        } else if (data) {
            navigateV2('/admin/store/order/lisp');
        }
    };
    const widthDimensions = useWindowDimensions();
    const [mobile, setMobile] = useState('');
    useEffect(() => {
        widthDimensions < 992 ? setMobile(true) : setMobile(false);
    }, [widthDimensions]);
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        setElAgree(false);
    }, [activeElem]);
    const closeHandler = () => {
        setShowModal(!showModal);
    };
    const measuredRef = useRef(null);
    const height = useWindowDimensionsHeight();
    const [selectElementConfig, setSelectElementConfig] = useState({
        className: 'adminTableFilterSelectSort',
        controlClassName: 'adminTableFilterSelect-dropdown-control',
        arrowClassName: 'adminTableFilterSelect-dropdown-arrow',
        options: selectElementItemsArr ? selectElementItemsArr.filter((el) => !el.hidden).map((el) => el.title) : [],
        value: selectedElLengthItems,
        onChange: changeSelectElement
    });
    const clickHandler = () => {
        setSelectElementConfig({
            ...selectElementConfig,
            menuClassName: height - 250 < measuredRef.current.getBoundingClientRect().bottom ? 'Dropdown-menu-top' : ''
        });
    };
    return activeElem && activeElem.length > 0 ? (
        mobile ? (
            <Portal unscrollable={false} customClass={'modalBottom modalBottomDown'} fullWidth={true} closeHandler={closeHandler}>
                <div {...getStyleProps('modalWindow', 'modalWindowDown')}>
                    <div {...getStyleProps('modalWindowTitleWrap')}>
                        <div
                            onClick={() => {
                                closeHandler(false);
                            }}
                            {...getStyleProps('modalWindowTitleWrapDecor')}
                        />
                        <p {...getStyleProps('modalWindowDownTitle')}>
                            <div>{t('selected', 'Выбрано', 'all', allTranslation?.translation)}: &nbsp;</div>
                            <div>
                                {activeElem.length}{' '}
                                {declOfNum(activeElem.length, [
                                    t('gridHeader-order', 'заказ', 'widget', translation, 'gridFilter'),
                                    t('gridHeader-order2', 'заказа', 'widget', translation, 'gridFilter'),
                                    t('gridHeader-order3', 'заказов', 'widget', translation, 'gridFilter')
                                ])}
                            </div>
                        </p>
                    </div>
                    {showModal && (
                        <div {...getStyleProps('modalWindowDownBody')}>
                            <div {...getStyleProps('modalWindowDownBodyItemTitle')}>
                                {t('gridHeader-ChangeStatusOn', 'Изменить статус на', 'widget', translation, 'gridFilter')}:
                            </div>
                            <div {...getStyleProps('modalWindowDownBodyItem')}>
                                <DropdownElement
                                    componentConfig={{
                                        ...selectElementConfig,
                                        menuClassName: 'Dropdown-menu-top'
                                    }}
                                />
                            </div>
                            <div {...getStyleProps('orderButtons')}>
                                <FormButtons
                                    sendFormData={changeFunc}
                                    customFormButton={{
                                        ok: {
                                            singleButton: compStyles.okButtonOrder,
                                            butWrapper: compStyles.okButtonOrderWrapper,
                                            butText: compStyles.okButtonOrderText
                                        },
                                        cancel: {
                                            singleButton: compStyles.cancelButtonOrder,
                                            butWrapper: compStyles.cancelButtonOrderWrapper,
                                            butText: compStyles.okButtonOrderText
                                        }
                                    }}
                                    buttons={[
                                        {
                                            type: 'cancel',
                                            buttonText: t('cancel', 'Отмена', 'all', allTranslation?.translation),
                                            clickFunc: () => setShowModal(false)
                                        },
                                        {
                                            type: 'ok',
                                            buttonText: t('apply', 'Применить', 'all', allTranslation?.translation)
                                        }
                                    ]}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </Portal>
        ) : (
            <div {...getStyleProps('selectElemWrapper')} ref={measuredRef} onClick={clickHandler}>
                <div {...getStyleProps('selectElemItem')}>
                    <div {...getStyleProps('selectElemItemText')}>
                        {t('selected', 'Выбрано', 'all', allTranslation?.translation)}:
                    </div>
                    <div>
                        {activeElem.length}{' '}
                        {declOfNum(activeElem.length, [
                            t('gridHeader-order', 'заказ', 'widget', translation, 'gridFilter'),
                            t('gridHeader-order2', 'заказа', 'widget', translation, 'gridFilter'),
                            t('gridHeader-order3', 'заказов', 'widget', translation, 'gridFilter')
                        ])}
                    </div>
                </div>
                <div {...getStyleProps('selectElemItem')}>
                    <p {...getStyleProps('selectPageText')}>
                        {selectData.textSelect ||
                            (mobile
                                ? t('change', 'Изменить', 'all', allTranslation?.translation)
                                : t('gridHeader-ChangeOn', 'Изменить на', 'widget', translation, 'gridFilter'))}
                        :
                    </p>
                    <DropdownElement componentConfig={selectElementConfig} />
                    {elAgree && (
                        <div {...getStyleProps('selectWindowAgree')}>
                            <div {...getStyleProps('selectWindowAgreeTitle')}>
                                {t('gridHeader-ChangeStatus', 'Изменить статус', 'widget', translation, 'gridFilter')}?
                            </div>
                            <SingleButton
                                key={'buttonOk'}
                                customStyles={compStyles}
                                type='ok'
                                clickFunc={changeFunc}
                                buttonText={t('yes', 'Да', 'all', allTranslation?.translation)}
                            />
                        </div>
                    )}
                </div>
            </div>
        )
    ) : (
        <></>
    );
};
export default SelectElement;
